export default __webpack_public_path__ + "static/media/devices_qr_code.654311f8.svg";